import { useState } from "react";
import { improveTextAI } from "../lib/claude";
import { useSettings } from "../store/settings";

interface Props {
  value: string;
  onApply: (improved: string) => void;
  mode: "title" | "brief" | "prompt";
  context?: string;
  className?: string;
  label?: string;
}

export function AIImproveButton({ value, onApply, mode, context, className, label }: Props) {
  const settings = useSettings();
  const [busy, setBusy] = useState(false);

  const handle = async () => {
    if (!value.trim()) { alert("Escreva algo primeiro pra eu melhorar."); return; }
    if (!settings.anthropicKey) { alert("Configure chave Anthropic em ⚙️."); return; }
    setBusy(true);
    try {
      const out = await improveTextAI({
        apiKey: settings.anthropicKey,
        model: "claude-haiku-4-5",  // sempre Haiku — rápido e barato
        text: value, mode, context
      });
      if (out) onApply(out);
    } catch (e) {
      alert("Falha: " + (e as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handle}
      disabled={busy}
      title={`Melhorar ${mode} com IA`}
      className={`btn btn-fire text-[10px] py-1 px-2 disabled:opacity-50 ${className ?? ""}`}>
      {busy ? "…" : (label ?? "🪄 IA")}
    </button>
  );
}
